import { apiFetch } from '@ami/react/core';
import { CustomerApprovalView } from '@ami/react/shared';

const _baseEndPoint = 'customer-approval-lookup';

export default {
  search: async (customerApprovalId) => {
    const url = `${_baseEndPoint}/${customerApprovalId}/search`;
    const result = await apiFetch(url, 'GET', null, null, true);
    return result;
  },
  getView: async (id) => {
    const entity = await apiFetch(
      `${_baseEndPoint}/${id}/view`,
      'GET',
      null,
      null,
      true
    );
    return new CustomerApprovalView(entity);
  },
  approve(id, fullName) {
    return apiFetch(
      `${_baseEndPoint}/approve`,
      'POST',
      { customerApprovalId: id, fullName: fullName },
      {
        automaticSuccessNotification: false,
      },
      true
    );
  },
  reject(id, fullName, rejectReason, privateDocument) {
    return apiFetch(
      `${_baseEndPoint}/reject`,
      'POST',
      {
        customerApprovalId: id,
        fullName: fullName,
        rejectReason: rejectReason,
        privateDocument: privateDocument,
      },
      {
        automaticSuccessNotification: false,
      },
      true
    );
  },
  viewed: async (id, fullName) => {
    return apiFetch(
      `${_baseEndPoint}/${id}/Viewed`,
      'POST',
      { fullName: fullName },
      {
        automaticSuccessNotification: false,
      },
      true
    );
  },
};
